module.exports = __webpack_public_path__ + "static/media/42.a1036f6e.jpg";